import { inject, Injectable, Injector } from '@angular/core';

// @ts-ignore
import Keycloak from 'keycloak-js';
import { SecurityService } from '../security.service';

import { environment as ENV } from '@environments/environment';



@Injectable({
  providedIn: 'root'
})
export class KeycloakService {

  private keycloak: Keycloak;


  constructor(
    private readonly injector: Injector,
  ) {
    this.keycloak = new Keycloak({
      url: ENV.OAUTH2.URL,
      realm: ENV.OAUTH2.REALM,
      clientId: ENV.OAUTH2.ID,
    });
  }


  public init(): Promise<boolean> {
    return this.keycloak.init({
      redirectUri: window.location.origin,
      onLoad: 'login-required',
      checkLoginIframe: false
    }).then(async (authenticated: any) => {
      console.log('Authenticated:', authenticated);
      console.log({ keycloak: this.keycloak });
      sessionStorage.setItem('USER', JSON.stringify(await this.keycloak.loadUserProfile()));
      sessionStorage.setItem('KEYCLOAK', this.keycloak.token);

      const security = this.injector.get(SecurityService);
      security.fetchRentalUser();

      return authenticated;
    }).catch((err: any) => {
      console.error('Keycloak init error', err);
      return false;
    });
  }


  public getToken(): string {
    return sessionStorage.getItem('KEYCLOAK' || '') || '';
  }


  public logout(): Promise<void> {
    if (!!this.keycloak) {
      return this.keycloak.logout({ redirectUri: window.location.origin });

    } else { return Promise.reject('Keycloak instance is not initialized.'); }
  }


  public getUserInfo(): Keycloak.KeycloakProfile | undefined {
    return JSON.parse(sessionStorage.getItem('USER') || '');
  }


  private async refreshToken(): Promise<boolean> {
    if (!this.keycloak) {
      throw new Error('Keycloak instance is not initialized.');
    }

    try {
      await this.keycloak.updateToken(60); // Actualiza el token si quedan menos de 60 segundos
      return true;

    } catch (error) {
      console.error('Unable to refresh token', error);
      return false;
    }
  }
}
